import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export async function submitForm(payload) {
  const { data } = await client.post("/submit", payload);
  return data;
}

export async function createOrder(payload) {
  const { data } = await client.post("/payments/create-order", payload);
  return data;
}

export async function verifyPayment(payload) {
  const { data } = await client.post("/payments/verify", payload);
  return data;
}

export function loadRazorpay() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}
